{
  "version": 1,
  "asset_id": "16281220-d7f8-4f9a-aa13-fe28c287ccfc",
  "project_id": "765508a6-9c9d-45ab-81ce-ecfbc5eb2942",
  "url": "/__l5e/assets-v1/16281220-d7f8-4f9a-aa13-fe28c287ccfc/TouchLives.png",
  "r2_key": "a/v1/765508a6-9c9d-45ab-81ce-ecfbc5eb2942/16281220-d7f8-4f9a-aa13-fe28c287ccfc/TouchLives.png",
  "original_filename": "TouchLives.png",
  "size": 564969,
  "content_type": "image/png",
  "created_at": "2026-08-18T18:27:20Z"
}
